import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { computed, watch, ref } from 'vue';
  import { BasicTableProps } from '@/components/WeTable';
  import { get_user_operation_log } from '@/api/erp-more';
  
export default /*#__PURE__*/_defineComponent({
  props: {
    operation_group: { default: '' },
    afterClose: null,
    start_content: null,
    end_content: null,
    footerButtons: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { operation_group: any, afterClose?: Fn, start_content?: string, end_content?: string, footerButtons: any[] }

  
  const show = ref(false);
  const items = ref<any[]>([]);
  const longOperationInterval = ref<any>(null);

  const operation_group = computed(() => {
    return props.operation_group;
  });
  const title = computed(() => {
    return `操作日志: ${operation_group.value.replace(/103_oper__/g, '')} ${hasMore.value ? '' : '【已结束】'}`;
  });

  const afterClose = () => {
    if (props.afterClose) {
      props.afterClose();
    } else {
      window.location.reload();
    }
  };

  const hasMore = computed(() => {
    if (
      props.operation_group &&
      (props.operation_group.startsWith('00') || props.operation_group.startsWith('101_data_report__'))
    ) {
      return false;
    } else if (
      items.value &&
      items.value.length > 0 &&
      (items.value[0].content.includes('done, takes') || items.value[0].content === props.end_content)
    ) {
      return false;
    }
    return true;
  });

  const tableConfig = computed<BasicTableProps>(() => {
    return {
      columns: [
        { title: 'Time', dataIndex: 'log_time' },
        { title: 'Content', dataIndex: 'content' },
      ],
      useSearchForm: false,
      useFilterFromColumns: false,
      showTableHeader: false,
      immediate: false,
      pagination: { pageSize: 10 },
    };
  });

  const loop = () => {
    get_user_operation_log({ group: props.operation_group }).then((res: any[]) => {
      if (!hasMore.value) {
        if (longOperationInterval.value) {
          clearInterval(longOperationInterval.value);
        }
      }
      if (res.length) {
        res[res.length - 1].content = props.start_content || res[res.length - 1].content;
        if (res[0].content.includes('done, takes')) res[0].content = props.end_content || res[0].content;
      }

      items.value = res;
    });
  };
  const runLog = () => {
    items.value = [];
    longOperationInterval.value = setInterval(loop, 1000 * 3);
    loop();
  };
  const closeOperLog = () => {
    show.value = false;
    afterClose();
  };

  watch(operation_group, (val) => {
    show.value = !!val;
    if (val) {
      runLog();
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: show.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    centered: "",
    width: "800px",
    confirmLoading: _unref(hasMore),
    maskClosable: false,
    wrapClassName: "we-operlog_container"
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
    ]),
    closeIcon: _withCtx(() => [
      (_unref(hasMore))
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-name": "ReloadOutlined",
            class: "icon rotate_bg"
          }))
        : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            "icon-name": "CloseOutlined",
            class: "icon",
            onClick: closeOperLog
          }))
    ]),
    footer: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.footerButtons, (item, i) => {
        return (_openBlock(), _createBlock(_component_a_button, {
          disabled: _unref(hasMore),
          onClick: item.click,
          key: i,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"]))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_we_table, _mergeProps(_unref(tableConfig), { dataSource: items.value }), null, 16, ["dataSource"])
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})